<template>
    <div class="d-flex align-items-center gap-2 w-100 flex-wrap">
        <!-- Campo de búsqueda -->
        <div class="position-relative flex-grow-1">
            <input v-model="search" placeholder="Buscar..." class="form-control w-100" @input="applyFilter" />
        </div>

        <!-- Contenedor del filtro de estado y botón -->
        <div class="d-flex align-items-center flex-grow-3 gap-2">
            <button class="btn btn-link p-0 px-0 mt-3" @click.prevent="clearFilter">
                <i class="fa-solid fa-broom-wide fa-lg"></i>
            </button>
            <MenuSelectedFull
v-model="selectedFilterStatus" label="" apiurl="sales-statuses"
                :can-edit-and-add="false" />
        </div>

        <!-- Filtro de categoría -->
        <div class="flex-grow-2">
            <select
id="choices-category-filter" v-model="selectedFilter" class="form-control"
                name="choices-category-filter" @change="applyFilter">
                <option v-for="option in orderOptions" :key="option.value" :value="option.value">{{ option.text }}
                </option>
            </select>
        </div>

        <!-- Select para número de elementos por página -->
        <div>
            <select v-model.number="localItemsPerPage" class="form-select px-2" style="width: 60px !important;">
                <option value="6">6</option>
                <option value="9">9</option>
                <option value="30">30</option>
                <option value="50">50</option>
            </select>
        </div>

        <!-- Botones de vista y elementos eliminados -->
        <div class="d-flex">
            <button :key="localViewAsCard" class="btn btn-link p-0 px-2 mt-3" @click="toggleViewAsCard">
                <i :class="localViewAsCard ? 'fa-duotone fa-solid fa-list fa-lg' : 'fa-solid fa-grid-2 fa-lg'"></i>
            </button>
            <button :key="localShowDeleted" class="btn btn-link p-0 px-2 mt-3" @click="toggleShowDeleted">
                <i :class="localShowDeleted ? 'fa-solid fa-trash-undo fa-lg' : 'fa-solid fa-trash fa-lg'"></i>
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, defineEmits, defineProps, watch } from 'vue';
import MenuSelectedFull from "@/components/MenuSelectedFull.vue";

// Define los eventos emitidos por el componente
const emit = defineEmits(['applyFilter', 'updateItemsPerPage', 'updateViewAsCard', 'updateShowDeleted']);

// Define las propiedades recibidas por el componente
const props = defineProps({
    orderOptions: {
        type: Array,
        required: true
    },
    itemsPerPage: {
        type: Number,
        required: true
    },
    viewAsCard: {
        type: Boolean,
        required: true
    },
    showDeleted: {
        type: Boolean,
        required: true
    }
});

// Variables reactivas para el estado del componente
const localViewAsCard = ref(props.viewAsCard);
const localShowDeleted = ref(props.showDeleted);
const search = ref('');
const selectedFilter = ref('updated_at');
const localItemsPerPage = ref(props.itemsPerPage);
const selectedFilterStatus = ref('');

// Función para aplicar el filtro de búsqueda y categoría
const applyFilter = () => {
    emit('applyFilter', {
        search: search.value,
        selectedFilter: selectedFilter.value,
        filters: {
            status_id: selectedFilterStatus.value
        }
    });
};

const clearFilter = () => {
    selectedFilterStatus.value = null;
    applyFilter();
};

watch(selectedFilterStatus, () => {
    applyFilter();
});

// Función para actualizar el número de elementos por página
const updateItemsPerPage = () => {
    emit('updateItemsPerPage', localItemsPerPage.value);
};

// Función para cambiar entre vista de tabla y tarjeta
const toggleViewAsCard = () => {
    localViewAsCard.value = !localViewAsCard.value;
    emit('updateViewAsCard', localViewAsCard.value);
};

// Función para actualizar la visualización de elementos eliminados
const toggleShowDeleted = () => {
    localShowDeleted.value = !localShowDeleted.value;
    emit('updateShowDeleted', localShowDeleted.value);
};

// Emite el valor inicial de `viewAsCard` y `showDeleted` cuando se monta el componente
onMounted(() => {
    emit('updateViewAsCard', localViewAsCard.value);
    emit('updateShowDeleted', localShowDeleted.value);
});

// Observa cambios en props.itemsPerPage y actualiza localItemsPerPage
watch(() => props.itemsPerPage, (newItemsPerPage) => {
    localItemsPerPage.value = newItemsPerPage;
});

// Observa cambios en localItemsPerPage y emite el evento correspondiente
watch(localItemsPerPage, () => {
    updateItemsPerPage();
});

// Observa cambios en props.viewAsCard y actualiza localViewAsCard
watch(() => props.viewAsCard, (newViewAsCard) => {
    localViewAsCard.value = newViewAsCard;
});

// Observa cambios en props.showDeleted y actualiza localShowDeleted
watch(() => props.showDeleted, (newShowDeleted) => {
    localShowDeleted.value = newShowDeleted;
});
</script>

<style scoped>
.d-flex {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.position-relative {
    position: relative;
}

.position-absolute {
    position: absolute;
}

.top-50 {
    top: 50%;
}

.translate-middle-y {
    transform: translateY(-50%);
}

.w-100 {
    width: 100%;
}

.flex-grow-1 {
    flex-grow: 1;
}

.flex-grow-4 {
    flex-grow: 4;
}

.form-control {
    width: 100%;
}

.form-select {
    width: auto;
}
</style>